import { Component, AfterViewInit} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AssetProductLov } from '../asset-product-lov/asset-product-lov.component';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';
import { AssetTransfer } from '../../models/entities/asset-transfer';
import { AssetTransferService } from '../../services/asset-transfer.service';
import { AssetTransferLine } from '../../models/entities/asset-transfer-line';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { AssetTransferPipe } from '../../pipes/asset-transfer-pipe';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { AssetTransferType } from '../../enums/asset-transfer-type';
import { MatDialog } from '@angular/material/dialog';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';

@Component({
    selector: 'asset-transfer-widget',
    templateUrl: './asset-transfer-widget.component.html',
    styleUrls: ['./asset-transfer-widget.component.scss']
})

export class AssetTransferWidgetComponent extends BaseWidget implements AfterViewInit {

  assetTransfer               : AssetTransfer = new AssetTransfer();
  assetTransferLineColumns    = [];
  branchs                     : Branch[] = null;
  
 

  constructor(
      protected controlTablesService  : ControlTablesService,
      protected assetTransferService  : AssetTransferService,
      protected toastr                : ToastrService,
      protected dialog                : MatDialog,
      protected leanUtilsService      : LeanUtilsService) {
      super(toastr, leanUtilsService);
  }


//---------------------------------------------------------------------------------------
  ngOnInit(){    
    super.ngOnInit();         
    this.controlTablesService.branchsGet().then(branchs => {
      this.branchs = branchs; 
    }) 
    
    // New Asset Transfer case
    //------------------------------------------------------------------
    if (this.assetTransfer.inserted) {
      if (this.assetTransfer.assetTransferType == AssetTransferType.Transfer) {
        this.assetTransfer.toBranch = new Branch();
      }
      if (this.assetTransfer.assetTransferType == AssetTransferType.Assignment) {
        this.assetTransfer.partner = new Partner();
      }
    }
    //------------------------------------------------------------------

    this.processAssetTransfer();
  }
//---------------------------------------------------------------------------------------



//---------------------------------------------------------------------------------------
  ngAfterViewInit(): void {

    super.ngAfterViewInit();
          
    setTimeout(() => {
      this.setAssetTransferLineColumns();
    })
  }
//---------------------------------------------------------------------------------------

 //--------------------------------------------------------------------------------------------------------
 setEntity(assetTransfer: AssetTransfer) {
      this.assetTransfer  = { ...assetTransfer };
      this.assetTransfer.assetTransferLines = [];
      if (assetTransfer.assetTransferLines) {
        for (let assetTransferLine of assetTransfer.assetTransferLines) {
          this.assetTransfer.assetTransferLines.push({ ...assetTransferLine });
        }
      }
  }
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
  getEntity(){
    return this.assetTransfer;
  }
//--------------------------------------------------------------------------------------------------------


//-----------------------------------------------------------------------------------------------------------------------------
newAssetTransferLine(){
  let dialogRef = this.dialog.open(AssetProductLov);
  dialogRef.afterClosed().subscribe(result => {
    if(result){
      this.setAssetProduct(result);
    }
  });
}
//-----------------------------------------------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
setAssetProduct(assetProduct : AssetProduct){
  let nr : AssetTransferLine = new AssetTransferLine();
  nr.inserted           = true;
  nr.edit               = true;
  nr.assetProduct       = assetProduct;
  nr.quantity           = 0;
  this.assetTransfer.assetTransferLines.push(nr);

  this.assetTransfer.assetTransferLines = [...this.assetTransfer.assetTransferLines];  
}
//---------------------------------------------------------------------------------------




//---------------------------------------------------------------------------------------
assetTransferPipe  : AssetTransferPipe = new AssetTransferPipe();
getAssetTransferStatus() : string{
  return this.assetTransferPipe.transform(this.assetTransfer, 'progressLevel');
}
//---------------------------------------------------------------------------------------



/*


  setSelectedPartner(result : DataModalResponse){
    let partner = result.selectedRow as Partner;
    this.assetTransfer.partner = partner;
  }


<partner-lov  #partnerLov
  (onSelect) = "setSelectedPartner($event)">
</partner-lov>

<asset-product-lov  #assetProductLov
  (onSelect)  = "setAssetProduct($event)">
</asset-product-lov>
*/



  //------------------------------------------------------
  saveRow() : Promise<AssetTransfer>{

    if (this.assetTransfer.inserted){
      if (this.assetTransfer.assetTransferType == AssetTransferType.Transfer){
          if (! this.assetTransfer.toBranch.branchCode) {
            this.leanUtilsService.error("Prière d'indiquer l'agence destinataire  du transfert");
            return;
          }
      }
      
      if (this.assetTransfer.assetTransferType == AssetTransferType.Assignment){
        if (! this.assetTransfer.partner.partnerCode) {
          this.leanUtilsService.error("Prière d'indiquer le client bénéficiaire de l'affectation");
          return;
        }
      }
    }


    if ((! this.assetTransfer.assetTransferLines) || (this.assetTransfer.assetTransferLines.length == 0)){
      this.leanUtilsService.error("Aucune ligne référence produit n'a été saisie dans ce bon de transfert");
      return;
    }

    for (let assetTransferLine of this.assetTransfer.assetTransferLines){
      if (assetTransferLine.quantity <= 0) {
        this.leanUtilsService.error("Quantité saisie invalide pour la référence produit : " + assetTransferLine.assetProduct.name);
        return;
      }
    }

    return this.assetTransferService.assetTransferSave(this.assetTransfer);
  }

  afterValidate() {
    this.processAssetTransfer();
  }
  //------------------------------------------------------



  setAssetTransferLineColumns(){
    this.assetTransferLineColumns =[
      { prop : 'assetProduct.name',           name : 'Produit',           readOnly : true },
      { prop : 'quantity',                    name : 'Qté Transfert',     type : 'number'},
      { prop : 'assignedAssetsNumber',        name : 'Qté Affectée',      type : 'number', readOnly : true },
      { prop : 'acceptedAssetsNumber',        name : 'Qté Acceptée',      type : 'number', readOnly : true },
      { prop : 'rejectedAssetsNumber',        name : 'Qté Rejetée',       type : 'number', readOnly : true }
    ]

  }
  




//---------------------------------------------------------------------------------------
missingBarCodes             : number = 0;
processAssetTransfer(){


  //--  Missing Bar Codes Calculation ------------------------------------
  this.missingBarCodes = 0;
  for (let atl of this.assetTransfer.assetTransferLines){

    this.processAssetTransferLine(atl);

    for (let asset of atl.assets){
      if (asset.assetCode == asset.barCode){
          this.missingBarCodes++;
      }
    }
  }
  //--------------------------------------------------------------
  if ( (this.assetTransfer.assetTransferLines) && (this.assetTransfer.assetTransferLines.length > 0)){
    this.assetTransferLine = this.assetTransfer.assetTransferLines[0];
  }
}


//---------------------------------------------------------------------------------------
  processAssetTransferLine(assetTransferLine : AssetTransferLine){
    assetTransferLine.assignedAssetsNumber =  assetTransferLine.assets.length;
    assetTransferLine.acceptedAssetsNumber = 0;
    assetTransferLine.rejectedAssetsNumber = 0;
    for  (let asset  of assetTransferLine.assets){
      if(asset.rejected != undefined) {
        if(asset.rejected) {
          assetTransferLine.rejectedAssetsNumber++;
        } else {
          assetTransferLine.acceptedAssetsNumber++;
        }
      }
    }
  }
//---------------------------------------------------------------------------------------



//----------------------------------------------------------------------
getTitle(){
  if (this.assetTransfer.assetTransferType == AssetTransferType.Assignment) {
    return 'Affectations Client';
    } else {
      return 'Transferts Agence';
    }
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
assetTransferLine : AssetTransferLine
selectRow(assetTransferLine : AssetTransferLine){
  this.assetTransferLine = assetTransferLine;
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
showRejectionReason(asset : Asset){
  if (! asset.rejected) return;
    this.showError(asset.rejectionReason);
}
//----------------------------------------------------------------------

}
